import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import DialogContent from "@mui/material/DialogContent";

import styles from './tractionAI.module.scss';
import { AI_MAIN_OPTIONS } from "./constants";
import { AISelectScreen, AISetSWOTData, AISetTrendData } from "modules/tractionAI/store/tractionAI.actions";
import TractionAIScout from "modules/tractionAI/screens/scout";
import TractionAIInsights from "modules/tractionAI/screens/insights";
import TractionAIRecommend from "modules/tractionAI/screens/recommend";
import TractionAIPopulate from "modules/tractionAI/screens/populate";
import { isLocalhost } from "../../serviceWorker";
import { getCookie } from "../../common/helper";

const TractionAI = ({ selectedCouncil }) => {
  const dispatch = useDispatch();

  const { tractionAiReducer: { activeScreen }} = useSelector((state) => state);

  const parseData = (data) => {
    if (!data?.message || data.type === "ping") {
      return;
    }

    const extractedData = data.message;

    if (extractedData.screen === 'trend_analysis') {
      dispatch(AISetTrendData({
        fetching: extractedData.fetching,
        data: extractedData.data,
        fetched: !extractedData.fetching
      }));
    }

    if (extractedData.screen === 'swot') {
      dispatch(AISetSWOTData({
        fetching: extractedData.fetching,
        data: extractedData.data,
        fetched: !extractedData.fetching
      }));
    }
  };

  useEffect(() => {
    let socket;

    if (isLocalhost) {
      const uid = getCookie("uid");
      const accessToken = getCookie("access_token");
      const client = getCookie("client");

      socket = new WebSocket(
        `${process.env.REACT_APP_WSS}/cable?access_token=${accessToken}&client=${client}&uid=${uid}`,
      );
    } else {
      socket = new WebSocket(
        `${process.env.REACT_APP_WSS}/cable`,
      );
    }

    socket.onopen = () => {
      const msg = {
        command: "subscribe",
        identifier: JSON.stringify({
          council_id: selectedCouncil.id,
          channel: "AiProxyChannel",
        }),
      };
      socket.send(JSON.stringify(msg));
    };

    try {
      socket.onmessage = (event) => {
        const parsedData = JSON.parse(event.data);
        parseData(parsedData);
      };
      socket.onclose = () => {
        console.log("disconnected");
      };
      socket.onerror = (error) => {
        console.log("Error: " + JSON.stringify(error));
      };
    } catch (error) {
      console.log("Error catch: " + error);
    }

    return () => {
      socket.close();
      console.log("unmounted");
    };
  }, []);

  const handleOptionSelect = option => {
    dispatch(AISelectScreen({
      activeScreen: option.id
    }))
  };

  return (
    <DialogContent>
      {
        !activeScreen && (
          <>
            <h4 className="mb-5">How can I help you?</h4>
            <div className="d-flex flex-row align-items-start mb-3">
              {
                AI_MAIN_OPTIONS.map(option => (
                  <div
                    key={option.name}
                    className={styles.recommendationItem}
                    onClick={() => handleOptionSelect(option)}
                  >{option.name}</div>
                ))
              }
            </div>
          </>
        )
      }
      {
        activeScreen && (
          <>
            {activeScreen === "scout" && (
              <TractionAIScout />
            )}
            {activeScreen === 'insight' && (
              <TractionAIInsights />
            )}
            {activeScreen === 'recommend' && (
              <TractionAIRecommend />
            )}
            {activeScreen === 'populate' && (
              <TractionAIPopulate />
            )}
          </>
        )
      }
    </DialogContent>
  );
};

export default React.memo(TractionAI);
